import React from 'react';
import MarkdownWithViz from '../../MarkdownWithViz';

const reqPrefix = 'src/markdowns/welcome';
const req = require.context('!raw-loader!../../../markdowns/welcome', false, /\.(md|jsx)$/);

export default function Welcome() {
  return <MarkdownWithViz req={req} reqSource={req} reqPrefix={reqPrefix} />;
}
